import { getErrorMessage } from '_metronic/helpers/AlertHelper'
import { useT } from '_metronic/i18n/Metronici18n'
import { InfoAlert } from 'app/components'

/** Falha ao carregar o registro que o modal vai editar: diz o que houve, em vez de girar para sempre. */
export const ErroDeCarga = ({ error }: { error: unknown }) => {
  const { t } = useT()
  return (
    <InfoAlert variant='danger' role='alert' title={t('pagina.dispositivos.detalhe.erro')}>
      {getErrorMessage(error) ?? ''}
    </InfoAlert>
  )
}
